














import { Component, Vue, Prop } from 'vue-property-decorator';
import { EventBus } from '@/libs/com/MetaPattern/Product/IDE/Util/EventBus';
import { Diagram } from '@/libs/com/MetaPattern/MDA/Designer/Repository/Diagram';
import { BaseComponent } from '@/api/com/MetaPattern/MDA/MD/Base/BaseComponent';
import { EnumPersistenceStatus } from '@/api/com/MetaPattern/Core/Infrastructure/Common/EnumPersistenceStatus';
import { UIModelComponent } from '@/api/com/MetaPattern/MDA/MD/UIModel/UIModelComponent';

@Component({
  components: {}
})
export default class ToolBall extends Vue {
  hasCurModified: boolean; // 当前图表是否发生了修改
  hasModified: boolean; // 是否有修改的图表

  get saveFlag(): boolean {
    const diagram: Diagram = this.$store.state.ModuleMD.curDiagram;
    if (diagram && diagram !== null) {
      if (diagram.isModified) {
        return false;
      }
    } else {
      const component: BaseComponent = this.$store.state.ModuleMD.curComponent;
      if (component && component !== null && component.persistenceStatus !== EnumPersistenceStatus.None) {
        return false;
      }
    }
    return true;
  }

  get saveAllFlag(): boolean {
    const find = this.$store.state.ModuleMD.diagrams.find((diagram: Diagram) => diagram.isModified);
    if (find) {
      return false;
    }
    const findUIModel = this.$store.state.ModuleMD.uiModelComponents.find((uiModelComponent: UIModelComponent) => uiModelComponent.persistenceStatus !== EnumPersistenceStatus.None);
    if (findUIModel) {
      return false;
    }
    return true;
  }

  /** 处理菜单命令 */
  handleCommand(command: string) {
    EventBus.$emit('tool:command', command);
  }
}
